{
  "CHAT_LIST": {
    "LOADING": "Nahrávam konverzácie",
    "LOAD_MORE_CONVERSATIONS": "Načítavam viac konverzácií",
    "EOF": "Všetky konverzácie boli načítané 🎉",
    "LIST": {
      "404": "V tejto skupine neprebiehajú žiadne aktívne rozhovory."
    },
    "FAILED_TO_SEND": "Odoslanie zlyhalo",
    "TAB_HEADING": "Rozhovory",
    "MENTION_HEADING": "Zmienky",
    "UNATTENDED_HEADING": "Nevybavené",
    "SEARCH": {
      "INPUT": "Vyhľadávanie ľudí, konverzácií, uložených odpovedí.."
    },
    "FILTER_ALL": "Všetko",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Moje",
      "unassigned": "Nepriradené",
      "all": "Všetko"
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Otvorené"
      },
      "resolved": {
        "TEXT": "Vyriešené"
      },
      "pending": {
        "TEXT": "Čaká sa na"
      },
      "snoozed": {
        "TEXT": "Odložené"
      },
      "all": {
        "TEXT": "Všetko"
      }
    },
    "VIEW_FILTER": "Zobraziť",
    "SORT_TOOLTIP_LABEL": "Zoradiť konverzácie",
    "CHAT_SORT": {
      "STATUS": "Stav",
      "ORDER_BY": "Zoradiť podľa"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": "Vytvorené",
      "LAST_ACTIVITY": "Posledná aktivita:",
      "LAST_CUSTOMER_MESSAGE": "Posledná správa zákazníka:"
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Posledná aktivita: Najstaršie"
      },
      "last_activity_at_desc": {
        "TEXT": "Posledná aktivita: Najnovšie"
      },
      "created_at_desc": {
        "TEXT": "Vytvorené: Najnovšie"
      },
      "created_at_asc": {
        "TEXT": "Vytvorené: Najstaršie"
      },
      "priority_desc": {
        "TEXT": "Priorita: Najvyššia"
      },
      "priority_asc": {
        "TEXT": ""
      },
      "waiting_since_asc": {
        "TEXT": "Čaká na odpoveď: Najdlhšie"
      },
      "waiting_since_desc": {
        "TEXT": "Čaká na odpoveď: Najkratšie"
      },
      "last_customer_message_at_asc": {
        "TEXT": "Posledná správa zákazníka: Najstaršie prvé"
      },
      "last_customer_message_at_desc": {
        "TEXT": "Posledná správa zákazníka: Najnovšie prvé"
      },
      "priority_created_at_desc": {
        "TEXT": "Priorita + Vytvorené: Najnovšie prvé"
      },
      "priority_created_at_asc": {
        "TEXT": "Priorita + Vytvorené: Najstaršie prvé"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Obrázková správa"
      },
      "audio": {
        "CONTENT": "Hlasová správa"
      },
      "video": {
        "CONTENT": "Video správa"
      },
      "file": {
        "CONTENT": "Súbor v prílohe"
      },
      "location": {
        "CONTENT": "Lokácia"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "zdieľal/a url"
      },
      "contact": {
        "CONTENT": "Zdieľaný kontakt"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Zoradiť konverzáciu",
      "DROPDOWN_TITLE": "Zoradiť podľa",
      "ITEMS": {
        "LATEST": {
          "NAME": "Posledná aktivita",
          "LABEL": "Posledná aktivita"
        },
        "CREATED_AT": {
          "NAME": "Vytvorené",
          "LABEL": "Vytvorené"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Posledná správa používateľa",
          "LABEL": "Posledná správa"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Prijaté emailom",
    "VIEW_TWEET_IN_TWITTER": "Zobraz tweet na Twitteri",
    "REPLY_TO_TWEET": "Odpovedať na tento Tweet",
    "LINK_TO_STORY": "Prejsť na príbeh Instagramu",
    "SENT": "Úspešne odoslané",
    "READ": "Úspešne prečítané",
    "DELIVERED": "Úspešne doručené",
    "NO_MESSAGES": "Žiadne správy",
    "NO_CONTENT": "Žiaden obsah nie je k dispozícii",
    "HIDE_QUOTED_TEXT": "Skryť citovaný text",
    "SHOW_QUOTED_TEXT": "Ukázať citovaný text",
    "MESSAGE_READ": "Prečítané",
    "SENDING": "Odosiela sa",
    "SEARCH_MESSAGES": "Hľadať konverzácie",
    "SEARCH_INPUT_PLACEHOLDER": "Hľadať konverzácie...",
    "MESSAGE_USE_AS_TEMPLATE": "Vložiť do odpovede",
    "CARDS": {
      "ACTIONS": {
        "OPEN": "Otvoriť",
        "BUY": "Kúpiť"
      }
    },
    "HIDE_AUTOMATED_MESSAGE": "Skryť obsah automatickej odpovede",
    "SHOW_AUTOMATED_MESSAGE": "Zobraziť obsah automatickej odpovede",
    "AUTOMATED_MESSAGE": "Automatická odpoveď"
  }
}
